import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getProceedingOptions } from '@/module/Author/Proceeding';
import { ProceedingEdit } from '@/module/Author/Proceeding/ProceedingEdit';

export const Route = createFileRoute('/_auth/author/_author/proceeding/_proceeding/$proceedingId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { proceedingId } = Route.useParams();
  const { data: proceeding } = useSuspenseQuery(getProceedingOptions(proceedingId));

  return <ProceedingEdit proceeding={proceeding} />;
}
